<template>
  <el-form label-position="top" ref="form" class="text-left">
    <el-row :gutter="30">
      <el-col :span="24" :sm="14" :md="12">
        <el-form-item>
          <div v-for="(item, index) in images" :key="index">
            <p v-if="item.name == ''" class="mg-y-5">
              รูปภาพ: ขนาด 1920X550 px
            </p>
            <p v-else class="mg-y-5">รูปภาพที่ {{ index + 1 }}</p>

            <el-upload
              v-if="item.name == ''"
              class="upload-input-text"
              action="#"
              list-type="picture-card"
              :auto-upload="false"
              :show-file-list="false"
              :on-change="(file) => uploadImage(file, index)"
            >
              <template slot="trigger">
                <div class="flex-display">
                  <el-input class></el-input>
                  <el-button type="primary" class="light mg-l-4"
                    >แนบไฟล์</el-button
                  >
                </div>
              </template>
            </el-upload>

            <div
              v-else
              class="image-preview"
              :style="`background-image:url(` + item.url + `);`"
            >
              <i
                @click="delImage(item.name)"
                class="fas fa-times-circle icon-preview-image"
              ></i>
            </div>
          </div>
          <a @click="addImage" class="color-primary-light">+ เพิ่มรูปภาพ</a>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
export default {
  props: {
    imageBanner: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      images: [],
      usrlSystem: process.env.VUE_APP_BASE_URL_SYSTEM,
    };
  },
  watch: {
    imageBanner() {
      this.images = this.getImags();
    },
  },
  mounted() {
    this.images = this.getImags();
  },
  methods: {
    getImags() {
      let imageAll = [];

      this.imageBanner.map((item) => {
        imageAll.push({
          name: item.file,
          type: item.type,
          url: `${this.usrlSystem}${item.file}`,
        });
      });

      imageAll.push({ name: "", type: "", url: "" });

      return imageAll;
    },
    uploadImage(file) {
      this.$emit("saveGeneralInfornation", {image:file.raw});
    },
    addImage() {
      this.images.push({ name: "", type: "", url: "" });
    },
    delImage(file) {
      this.$emit("saveGeneralInfornation", {delImage:file});
    },
  },
};
</script>

<style scoped>
.image-preview {
  width: 100%;
  height: 300px;

  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  border-radius: 5px;
  position: relative;
}
.icon-preview-image {
  position: absolute;
  right: -4px;
  top: -4px;
  color: #c4c4c4;
  cursor: pointer;
  background: #fff;
  border-radius: 20px;
}
</style>
